import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0660. 発注案件関連受注案件削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/related_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const destroyRelatedOrder = (props: Props): Promise<PaymentSchedule> => {
  return axios.delete(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/related_orders/${props.id}`);
};

export const useDestroyRelatedOrder = () => {
  return useMutation({
    mutationFn: destroyRelatedOrder,
  });
};
